import { FC } from 'react';
import { Box, Button, ButtonAppearance, ButtonProps, ButtonSize } from '@bechtel/gds';
import styled, { css } from 'styled-components';

const boxShadow =
  '0 1px 5px 0 rgba(0, 0, 0, 0.2), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 2px 2px 0 rgba(0, 0, 0, 0.14);';

export const WeldFlangeSideSheetContentColStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
  flexGrow: { sm: 1 },
})`
  box-shadow: ${boxShadow};
  overflow-y: hidden;
  height: 100%;
`;

export interface TabButtonProps extends ButtonProps {
  selected: boolean;
}

export const TabButtonStyled = styled(Button as FC<TabButtonProps>).attrs({
  appearance: ButtonAppearance.TERTIARY,
  size: ButtonSize.SMALL,
})`
  width: 50%;
  min-width: 110px;
  border: none;
  border-radius: 0;
  position: relative;
  &:focus {
    border-color: transparent;
    box-shadow: none;
  }
  ${({ theme }) => css`
    background-color: ${theme.colors.white};
    color: ${theme.colors.grey[1000]};
    font-size: ${theme.fontSizes['400']};
    padding-top: ${theme.spacings[550]};
    padding-bottom: ${theme.spacings[550]};

    &::after {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      height: 5px;
      background-color: ${theme.colors.blue['700']};
      opacity: 0;
    }
  `};
  ${(props) =>
    props.selected &&
    css`
      font-weight: ${props.theme.fontWeights[600]};
      &::after {
        opacity: 1;
      }
    `};
`;

export const WeldFlangeTabStyled = styled(Box)`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.white};
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey[300]};
`;
